import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    :root{
        --white: #fff;
        --black: #000;
        --lightGreen: #f0f0f0;
        --lightGrey: #eee;
        --medGrey: #353535;
        --darkGrey: #1c1c1c;
        --morienGreen: #009527;
        --fontSuperBig: 2.5rem;
        --fontBig: 1.5rem;
        --fontMed: 1.2rem;
        --fontSMed: 1.1rem;
        --fontNormal: 1rem;
        --fontSmall: 0.9rem;
        --fontSSmall: 0.8rem;

    }
    
    * {
        box-sizing: border-box;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
            'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
            sans-serif;
        
    }
    html{
        height: 100%;
        font-size: 14px;
        letter-spacing: 0.9px;
    }

    body {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow:hidden;
        margin: 0;
        padding: 0;
        height: 100%;
        
        h1 {
            font-size: 2rem;
            font-weight: 600;
        }

        h3 {
            font-size: 1.1rem;
            font-weight: 600;
        }

        p {
            font-size: 1rem;
        }

        #root{
            height: 100%;
        }
    }
    @keyframes fadeIn {
        from { opacity: 0;}
        to { opacity: 1;}
    }

    @keyframes TransformRight {
        from { transform : translateX(100%);}
        to {transform : translateX(0);}
    }

`;
